import React from "react";
import styled from "styled-components";
import Input from "./Input";

interface Option {
  value: string;
  label: string;
}

interface Props {
  value: Option;
  onChange: (option: Option) => void;
  buttonSize?: number;
  minWidth?: number | string;
  height?: number;
}

export const TwoInputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
`;

const OptionInput = (props: Props) => {
  const { value, onChange, buttonSize, minWidth, height } = props;

  return (
    <TwoInputWrapper>
      <Input
        placeholder="Label"
        required
        value={value.label}
        onChange={(label) => onChange({ ...value, label })}
        autoFocus
        buttonSize={buttonSize}
        minWidth={minWidth}
        height={height}
      />
      <Input
        placeholder="Value"
        required
        value={value.value}
        onChange={(v) => onChange({ ...value, value: v })}
        buttonSize={buttonSize}
        minWidth={minWidth}
        height={height}
      />
    </TwoInputWrapper>
  );
};

export default OptionInput;
